import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateActivityCategoryService } from '@wilson/activity-categories/data';
import { ActivityCategory } from '@wilson/interfaces';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'wilson-activity-category-confirm-modal',
  templateUrl: './activity-category-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ActivityCategoryConfirmModalComponent {
  private modal = inject(NzModalRef);
  private readonly translateActivityCategoryService = inject(
    TranslateActivityCategoryService,
  );

  added: ActivityCategory[] = [];
  removed: ActivityCategory[] = [];
  handbookUrl = '';

  get addedNames(): string {
    return this.added
      .map((c) => this.translateActivityCategoryService.resolve(c))
      .join(', ');
  }

  get removedNames(): string {
    return this.removed
      .map((c) => this.translateActivityCategoryService.resolve(c))
      .join(', ');
  }

  get hasPayableTimeAdded(): boolean {
    return this.added.some((c) => c.isPayableTime);
  }

  cancel(): void {
    this.modal.destroy(false);
  }

  confirm(): void {
    this.modal.destroy(true);
  }
}
